// extracted by mini-css-extract-plugin
var _1 = "tab-mobile__jAy8w";
export { _1 as "tabMobile" }
